import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TabItem } from 'src/app/models/common/tab-items';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: 'sym-agent-party-address-tabs',
  templateUrl: './agent-party-address-tabs.component.html',
  styleUrls: ['./agent-party-address-tabs.component.scss'],
})
export class AgentPartyAddressTabsComponent extends BaseComponent<AgentService> implements OnChanges {
  addressTabList: TabItem[];
  selectedAddressTab: TabItem;
  @Input() responseUpdated: boolean;
  @Input() partyModel: any;
  isSelectDisplay: boolean;
  isAddressFieldsDisplay: boolean;
  status: string;
  constructor(agentServie: AgentService, public settingService: SettingService) {
    super(agentServie);
    this.isSelectDisplay = true;
    this.isAddressFieldsDisplay = true;
  }
  ngOnInit() {
    this.loadAddressTab();
  }
  ngOnChanges(changes: SimpleChanges) {
    //  if (this.model != undefined) {
    //   this.partyModel = this.model;
    // }

    super.ngOnChanges(changes);
  }

  displaySelectedTabBody(tab: TabItem) {
    console.log('tab', tab);
    if (tab.id == 'OfficeAddress') this.isSelectDisplay = true;
    // else this.isSelectDisplay = false;

    if (this.isSelectDisplay) this.selectedAddressTab = tab;
  }

  private loadAddressTab() {
    let addressList = ['ResidentalAddress', 'OfficeAddress'];
    this.addressTabList = [];
    addressList.filter((addressType) => {
      if (this.partyModel[addressType] != undefined) {
        let tab = new TabItem();
        tab.text = this.settingService.getLabelValue(addressType);
        tab.isSelected = false;
        tab.id = addressType;
        this.addressTabList.push(tab);
      }
    });

    if (this.addressTabList.length > 0) {
      this.addressTabList[0].isSelected = true;
      this.selectedAddressTab = null;
      this.selectedAddressTab = this.addressTabList[0];
    }
  }

  async copyFromAddr2_change(item: FieldItem) {
    let partyModel = this.service.responseIO.data.AgentParty.OfficeAddress;
    if (item.model[item.fieldCd] != null) {
      // this.isSelectDisplay = true;
      this.isAddressFieldsDisplay = false;
      partyModel = this.service.responseIO.data.AgentParty.OfficeAddress;
    } else {
      this.isAddressFieldsDisplay = true;
    }

    await this.addClearPartyDetails(partyModel, item.model[item.fieldCd]);
  }

  public addClearPartyDetails(partyModel: any, selectedValue): void {
    console.log('selectedValue', selectedValue);
    Object.keys(partyModel).forEach((key: any) => {
      if (key != 'id' && key != 'guid' && key != 'versionID' && key != 'addressTypeCd') {
        if (selectedValue != null) {
          this.service.setModelFieldValue(
            partyModel,
            key,
            this.service.responseIO.data.AgentParty.ResidentalAddress[key]
          );
        } else {
          console.log('partyModel --->', partyModel);
          if (typeof partyModel[key] != 'object') {
            this.service.setModelFieldValue(partyModel, key, null);
          } else if (partyModel[key] != undefined && typeof partyModel[key] === 'object') {
            //this is required child model of party ie. party address
            this.addClearPartyDetails(partyModel[key], selectedValue);
          }
          console.log('partyModel', partyModel);

          // this.onInputChanged(partyModel);
        }
      } // else if (partyModel[key] != undefined && typeof partyModel[key] === 'object') {
      //   // this is required child model of party ie. party address
      //   this.clearPartyDetails(partyModel[key]);
      // }
    });
    partyModel['status'] = 'N';
    this.service.setUpdated(partyModel);
  }
}
